import { Button } from "@/components/ui/Button"

import { StudentProfileController } from "./StudentProfile.controller"

interface StudentProfileProps {
  controller: StudentProfileController
}

export function StudentProfile({ controller }: StudentProfileProps) {
  return (
    <div className="tw-container tw-p-2">
      <h1 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-text-center">
        Student Profile
      </h1>
      <div className="tw-px-5">
        <Button variant="destructive">Delete Account</Button>
      </div>
    </div>
  )
}
